module.exports = __webpack_public_path__ + "img/oee_report_bottom.f633c5fc.jpg";